var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuya(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 107,
    viewBox: "0 0 130 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35156 10.8852C7.35156 10.8852 11.5137 56.7331 65.1982 57.5831C138.825 58.7491 120.837 104.272 120.837 104.272",
    stroke: "#FF751F",
    strokeWidth: 14.0526,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0989 0.720716C63.0989 0.720716 76.4084 128.949 3.74317 83.2051",
    stroke: "#FF751F",
    strokeWidth: 14.0526,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3532 36.0706C47.4479 36.092 51.5954 31.9793 51.6168 26.8846C51.6383 21.7899 47.5256 17.6424 42.4309 17.621C37.3361 17.5995 33.1887 21.7122 33.1672 26.807C33.1458 31.9017 37.2585 36.0491 42.3532 36.0706Z",
    fill: "#FF751F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuya);
export default __webpack_public_path__ + "static/media/ruya.5348423329b5e062142f5a9a2c7ced2d.svg";
export { ForwardRef as ReactComponent };